/**
 * @generated SignedSource<<81b01c520718965851170ab5aeafc8d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TermsSelectRefetchQuery$variables = {
  search?: string | null;
};
export type TermsSelectRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TermsSelect_data">;
};
export type TermsSelectRefetchQuery = {
  response: TermsSelectRefetchQuery$data;
  variables: TermsSelectRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TermsSelectRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "TermsSelect_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TermsSelectRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 10
          },
          (v1/*: any*/)
        ],
        "concreteType": "TermConnection",
        "kind": "LinkedField",
        "name": "terms",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TermEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Term",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3cb108edb11e9bf0e5ab22a0a88dd87b",
    "id": null,
    "metadata": {},
    "name": "TermsSelectRefetchQuery",
    "operationKind": "query",
    "text": "query TermsSelectRefetchQuery(\n  $search: String\n) {\n  ...TermsSelect_data_40zwac\n}\n\nfragment TermsSelect_data_40zwac on Query {\n  terms(first: 10, search: $search) {\n    edges {\n      node {\n        id\n        name\n        icon\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "605a83c9e02ca24bc611e8024ceca347";

export default node;
